import { collaborationApiAdapter } from 'Api/index';

export default class DocCollaborationApi {
  constructor() {}
  async getUserToken() {
    return collaborationApiAdapter.callFunction('base', 'getUserToken', '');
  }
  async getCDocInfo(cDocId) {
    return collaborationApiAdapter.callFunction('base', 'getCDocInfo', { cDocId }); // 新增
  }
  async getCurrentDoc() {
    return collaborationApiAdapter.callFunction('base', 'getCurrentDoc', '');
  }
  async getFileStream({ file, offset, blockSize }) {
    return collaborationApiAdapter.callFunction('base', 'getFileStream', { file, offset, blockSize });
  }
  async getReviewSessionID() {
    return collaborationApiAdapter.callFunction('base', 'getReviewSessionID', '') // 新增，只有Phantom才会调用
  }
  async openSharedFile({docId, docName, fileLink, reviewSessionID, success, error}) {
    return collaborationApiAdapter.callFunction('StartPage', 'openSharedFile', {docId, docName, fileLink, reviewSessionID, success, error}) // 新增
  }

  async inviteResult({res}) {
    return collaborationApiAdapter.callFunction('base', 'inviteResult', res) // 新增
  }
  async unSharedFileResult({res}) {
    return collaborationApiAdapter.callFunction('base', 'unSharedFileResult', res) // 新增
  }
  async deleteSharedFileResult({res}) {
    return collaborationApiAdapter.callFunction('base', 'deleteSharedFileResult', res) // 新增
  }
  async closeWindow() {
    return collaborationApiAdapter.callFunction('base', 'closeWindow', '') // 新增，只有Phantom才会调用
  }
  async uploadInitialAnnots({reviewSessionID}) {
    return collaborationApiAdapter.callFunction('base', 'uploadInitialAnnots', {reviewSessionID}) // 新增，只有Phantom才会调用
  }
  async postWinSizeMsg({name, width, height}) {
    return collaborationApiAdapter.callFunction('base', 'winSizeMsg', {name, width, height})
  }
  async postDownloadFileLink({ url }) {
    return collaborationApiAdapter.callFunction('base', 'postDownloadFileLink', {url})
  }
  async postChooseFile() {
    return collaborationApiAdapter.callFunction('base', 'postChooseFile', '')
  }
  async postErrorMsg({type,errorInfo}) {
    return collaborationApiAdapter.callFunction('base', 'postErrorMsg', {type,errorInfo})
  }
}
